// CompleteTrainingModal.jsx
import React, { useState, useEffect } from 'react';
import './CompleteTrainingModal.css';

const CheckCircleIcon = ({ width = 20, height = 20 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const XIcon = ({ width = 20, height = 20 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const CompleteTrainingModal = ({ isOpen, onClose, onConfirm, itemName, employeeName }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Устанавливаем текущую дату по умолчанию при открытии модального окна
  useEffect(() => {
    if (isOpen) {
      const today = new Date().toISOString().split('T')[0];
      setSelectedDate(today);
      setIsSubmitting(false);
    }
  }, [isOpen]);

  const handleConfirm = async () => {
    if (!selectedDate) {
      return;
    }
    
    setIsSubmitting(true);
    try {
      await onConfirm(selectedDate);
      onClose();
    } catch (error) {
      console.error('Ошибка при отметке обучения:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="complete-modal-overlay" onClick={handleOverlayClick}>
      <div className="complete-modal-container">
        <div className="complete-modal-header">
          <div className="complete-modal-title">
            <CheckCircleIcon />
            <h3>Отметить обучение как пройденное</h3>
          </div>
          <button className="complete-modal-close" onClick={onClose}>
            <XIcon width={18} height={18} />
          </button>
        </div>

        <div className="complete-modal-body">
          <div className="complete-modal-info">
            <p className="complete-modal-course">
              <span className="complete-modal-label">Курс:</span>
              <span className="complete-modal-value">{itemName || '—'}</span>
            </p>
            {employeeName && (
              <p className="complete-modal-employee">
                <span className="complete-modal-label">Сотрудник:</span>
                <span className="complete-modal-value">{employeeName}</span>
              </p>
            )}
          </div>

          <div className="complete-modal-field">
            <label className="complete-modal-field-label">
              Дата прохождения обучения
            </label>
            <input
              type="date"
              className="complete-modal-date-input"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              max={new Date().toISOString().split('T')[0]}
            />
            <p className="complete-modal-hint">
              Укажите дату, когда сотрудник завершил обучение
            </p>
          </div>
        </div>

        <div className="complete-modal-footer">
          <button className="complete-modal-btn-cancel" onClick={onClose}>
            Отмена
          </button>
          <button 
            className="complete-modal-btn-confirm" 
            onClick={handleConfirm}
            disabled={!selectedDate || isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="complete-modal-spinner"></span>
                Сохранение...
              </>
            ) : (
              'Отметить как пройденное'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompleteTrainingModal;